import { render, staticRenderFns } from "./dist.vue?vue&type=template&id=46960b50&"
import script from "./dist.vue?vue&type=script&lang=js&"
export * from "./dist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports